<template>
  <v-card>
    <v-toolbar style="background-color: #770707; color: #fff">
      <!-- <v-toolbar style="background-color: #1daf80; color: #fff"> -->
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span class="headline">Sangria Caixa</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items> </v-toolbar-items>
    </v-toolbar>
    <div class="px-8 py-6">
      <!-- <button
        @click.prevent="teste"
        class="btn btn-app-primary btn-rounded font-weight-bold"
      >
        <span> Check Caixa </span>
      </button> -->
      <v-card>
        <div>
          <v-card-title class="mx-2"><h3>Caixa</h3></v-card-title>
          <div class="px-3 row md-0 justify-content-between">
            <div class="col-3 text-start">
              <p style="text-capitalize">
                <strong>Usuario:</strong><br />
                {{ getNomeUsuario() }}
              </p>
            </div>
            <div class="col-3 text-start">
              <p>
                <strong>Unidade:</strong><br />
                {{ getUnidade() }}
              </p>
            </div>
            <div class="col-3 text-start">
              <p>
                <strong>Data Abertura:</strong><br />
                {{ formatarData(caixa.data_abertura) }}
              </p>
            </div>
            <div class="col-3 text-start">
              <p>
                <strong>Hora Abertura:</strong><br />
                {{ caixa.hora_abertura }}
              </p>
            </div>
          </div>
          <div class="px-3 my-0 row justify-content-center">
            <div class="col-md-4 text-start">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      ><strong>Saldo</strong></v-list-item-title
                    >
                    <v-list-item-subtitle>
                      {{
                        formatarSaldo(this.caixaResumo.saldo)
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </div>
      </v-card>
      <div class="row justify-content-center mt-5">
        <div class="col-lg-8 form-group clearfix ">
          <v-textarea
            label="Observação"
            v-model="observacao"
            placeholder=" "
            rows="2"
            counter="255"
            maxlength="255"
          ></v-textarea>
        </div>
      </div>
      <div class="row justify-content-center ">
        <div class="col-lg-4 form-group clearfix mb-3">
          <v-text-field
            v-model.lazy="valorCaixa"
            v-money="moneyConfig"
            @keydown="verificarTecla($event)"
            type="text"
            step="0.01"
            min="0"
            label="Valor Sangria"
            style="padding-top: 0 !important"
          ></v-text-field>
        </div>
        <div class="col-4 text-right ">
          <v-btn
            :dark="validarDisable('dark')"
            color="#770707"
            :disabled="validarDisable('disabled')"
            @click.prevent="sangriaCaixa"
          >
            <span v-if="!loading"> Realizar Sangria </span>
            <v-progress-circular
              v-else
              indeterminate
              color="white"
            ></v-progress-circular>
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import Mixin from "@/mixins/vuex_mixin.js";
import CaixaService from "../../services/caixa_service";
import { VMoney } from "v-money";

export default {
  mixins: [Mixin],
  props: {
    caixa: {
      type: Object,
      required: true,
    },
  },
  directives: { money: VMoney },
  data: () => ({
    moneyConfig: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: true,
    },
    caixaResumo: "",
    observacao: "",
    valorCaixa: 0.0,
    caixaAtual: 0.0,
    loading: false,
    services: {
      caixaService: CaixaService.build(),
    },
    unidadeId: ~~JSON.parse(sessionStorage.vuex).unidade.id,
    unidade: ~~JSON.parse(sessionStorage.vuex).unidade.razap_social,
    usuarioId: ~~JSON.parse(sessionStorage.vuex).usuario.id,
    usuario: ~~JSON.parse(sessionStorage.vuex).usuario.dados.nome,
  }),
  mounted() {
    this.detalheCaixa();
  },
  watch: {},
  methods: {
    validarDisable(tipo) {
      const valor = parseFloat(this.formatValor(this.valorCaixa));
      const caixa = parseFloat(this.caixaAtual);
      if (tipo === "disabled") {
        if (valor <= 0 || valor > caixa || this.observacao == "") {
          return true;
        } else {
          return false;
        }
      } else if (tipo === "dark") {
        if (valor <= 0 || valor > caixa || !this.observacao) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getNomeUsuario() {
      return JSON.parse(
        sessionStorage.getItem("vuex")
      ).usuario.dados.nome.toLowerCase();
    },
    getUnidade() {
      return JSON.parse(
        sessionStorage.getItem("vuex")
      ).unidade.nome.toLowerCase();
    },
    verificarTecla(event) {
      if (
        ((event.keyCode >= 65 && event.keyCode <= 90) ||
          (event.keyCode >= 97 && event.keyCode <= 122)) &&
        ![96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 188, 190].includes(
          event.keyCode
        )
      ) {
        event.preventDefault();
      }
    },
    formatarData(data) {
      if (data) {
        return data
          .split("-")
          .reverse()
          .join("/");
      } else {
        return "-";
      }
    },
    formatarSaldo(saldo) {
      saldo = saldo.replaceAll(",", "");
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(saldo);
    },
    detalheCaixa() {
      this.loadingDetalhe = true;
      this.services.caixaService
        .getCaixaResumo(
          this.caixa.id_usuario,
          this.caixa.id_unidade,
          this.caixa.id
        )
        .then(async (resp) => {
          console.log(resp);
          const response = await resp.json();
          if (resp.status == 200) {
            console.log(response);
            this.caixaResumo = response.data.resumo;
            this.caixaAtual = parseFloat(
              this.caixaResumo.saldo.replaceAll(",", "")
            ).toFixed(2);
          } else if (resp.status == 206) {
            console.log(response);
          } else {
            console.log(response);
          }
        })
        .catch((error) => {
          this.loadingDetalhe = false;
          console.error(error);
        })
        .finally(() => {
          this.loadingDetalhe = false;
        });
    },
    sangriaCaixa() {
      this.loading = true;
      let body = {
        unidade: this.caixa.id_unidade,
        caixa: this.caixa.id,
        valor: this.formatValor(this.valorCaixa),
        observacao: this.observacao,
      };
      this.services.caixaService
        .sangriaCaixa(body)
        .then(async (resp) => {
          const response = await resp.json();
          console.log(resp.status);
          this.loading = false;
          this.mostrarFeedback(resp.status, response);
          if (resp.status == 200) {
            this.$emit("response");
            this.$emit("close");
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mostrarFeedback(status, response) {
      this.$_ACTIONS_showSnackbarMessage({
        message:
          status == 200 ? "Sangria realizada com sucesso!" : response.message,
        color: status == 200 ? "sucess" : "error",
      });
    },
    formatValor(valor) {
      if (typeof valor == "string") {
        const newValor = parseFloat(
          valor
            .replaceAll("R$", "")
            .replaceAll(".", "")
            .replaceAll(",", ".")
        ).toFixed(2);
        return newValor;
      } else {
        return valor;
      }
      // return parseFloat(valor).toFixed(2)
    },
    resetForm() {
      this.valorCaixa = "";
    },
    getFormData() {
      return {
        valorCaixa: this.valorCaixa,
      };
    },
  },
};
</script>
<style scoped>
.text-capitalize {
  text-transform: capitalize !important;
}
</style>
